/* American Threads Co - name every variant row.

   atc-variant-row.css turns each button fieldset into a scrolling row, and
   Safari on iOS refuses to paint the <legend> of a fieldset that scrolls. The
   CSS paints the name as generated content instead, reading --atc-row-label;
   this file supplies the real text.

   2026-10-19: MIN dropped from 7 to 1. The CSS used to scroll only rows of
   seven or more values, so only those needed a painted name; now every button
   row scrolls, so every button row needs one. The CSS has no text fallback,
   which means a row this script misses is a row with no label at all - so the
   floor is 1, not 2, and rows of a single value are named too.

   The rule goes in a <head> stylesheet, not on the element: Horizon morphs the
   variant picker in place and wipes every attribute we set on it, but a
   stylesheet rule keyed on nth-of-type keeps matching. */
(function () {
  var MIN = 1, last = '';

  function run() {
    var sets = document.querySelectorAll('variant-picker fieldset.variant-option');
    var rules = [], sig = '';
    for (var i = 0; i < sets.length; i++) {
      var fs = sets[i];
      if (fs.querySelectorAll(':scope > label').length < MIN) continue;
      var lg = fs.querySelector('legend');
      var text = lg ? lg.textContent.trim() : '';
      if (!text) continue;
      var sibs = [].slice.call(fs.parentElement ? fs.parentElement.children : [])
        .filter(function (e) { return e.tagName === 'FIELDSET'; });
      var nth = sibs.indexOf(fs) + 1;
      if (nth < 1) continue;
      rules.push('variant-picker fieldset.variant-option:nth-of-type(' + nth +
        '){--atc-row-label:' + JSON.stringify(text) + ';}');
      sig += nth + ':' + text + '|';
    }
    if (!rules.length || sig === last) return;
    last = sig;
    var s = document.getElementById('atc-row-label');
    if (!s) {
      s = document.createElement('style');
      s.id = 'atc-row-label';
      document.head.appendChild(s);
    }
    s.textContent = rules.join('\n');
  }

  function start() {
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
